import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DealAppStatusSmartComponent } from './deal-app-status-smart/deal-app-status-smart.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { AlertModule } from 'app/components/alert/alert.module';
import { MatIconModule } from '@angular/material/icon';
import { FormlyMaskTypeComponent } from './input-mask-type';
import { NgxMaskModule } from 'ngx-mask';
import { FormCoreModule } from 'app/form-core/formly-core.module';

@NgModule({
  declarations: [
    DealAppStatusSmartComponent,
    FormlyMaskTypeComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    FormlyMaterialModule,
    FormlyModule,
    MatInputModule,
    MatProgressSpinnerModule,
    FormlyMatToggleModule,
    NgxMaskModule.forChild(),
    AlertModule,
    FormCoreModule,
    FormlyModule.forChild({
      types: [
      {
        name: 'customInputMask',
        component: FormlyMaskTypeComponent,
      }
    ]
    }),
  ],
  exports: [
    DealAppStatusSmartComponent
  ]
})

export class DealAppStatusModule { }
